module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Admin */

(function(fox) {
	'use strict';

	fox.registerWidget('Menu_Sidebar', {

		configure: function () {

			this.pageData = null;

			this.registerOptions('', {
				menusList: {},

				handleWom: {
					highlight: {
						widget: '@this',
						event: 'pageChanged',
						callback: '_handlePageChange'
					}
				}
			});

			this.registerOptions('.Widget', {
				autoRender: true,
				active: false,
				group: 'sidebarMenu',
				embed: {
					widget: '@parent @parent',
					container: '.mc-sidebar-menu'
				},
				handleWom: {
					highlight: {
						widget: '@this',
						event: 'addedToDom',
						callback: '@parent:_highlight',
						params: {
							prefix: 'menuSidebar'
						}
					}
				},
				templateOptions: {
					cookies: fox.cookie.cookies
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.embedWidgets(this.getOption('menusList'));

			this.callParent('init', arguments);
		},

		running: function () {
			this.layout = this.wom1('@parent');

			this.callParent('running', arguments);
		},

		activate: function() {
			this._reactivationPool = [];

			this.callParent('activate', arguments);
		},

		deactivate: function () {
			this.pageData = null;

			this.callParent('deactivate', arguments);
		},

		_handlePageChange: function (pageData) {
			//console.warn('sidebarMenu change', pageData)

			if (this.pageData && (this.pageData.page === pageData.page || this.pageData.section === pageData.section)) {
				//console.warn('just highlight !')
				this.pageData = pageData;
				this._highlightOnActiveWidget(pageData);

				return;
			}

			this.pageData = pageData;
			this.switchEmbeddedWidget(this.pageData.section);
		},

		_highlight: function (obj, w, alias) {
			this.highlight(w, this.pageData.page);
		},

		_highlightOnActiveWidget: function (pageData) {
			this.highlight(this._widgets[pageData.section], pageData.page);
		},

		highlight: function (w, page) {
			fox.each(w.dom('[data-link-alias]'), function (link) {
				link = fox.dom.wrap(link);

				link.up(0).removeClass('active');

				if (fox.inArray(link.attr('data-link-alias').split(','), page)) {
					link.up(0).addClass('active');
				}
			}, this);
		}

	}, 'Menu2');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/menu/sidebar.js
// module id = 328
// module chunks = 2